addEventListener("DOMContentLoaded", (event) => {
  if ( window.innerWidth > 989 ){
    // $(".selector_buttons_cont").slick({
    //       slidesToShow: 3,
    //       slidesToScroll: 3,
    //       arrows: true,
    //       dots: false,
    //       autoplay: false,
    //       autoplaySpeed: 2000,
    //       infinite: false
    // });
  }
});

// Set the section height dynamically
// document.getElementById('build_meal_plan').style.height = '652px';

window.addEventListener('scroll', function() {
    var section = document.getElementById('build_meal_plan');
    if(section){
      var sectionRect = section.getBoundingClientRect(); // Get the bounding rectangle of the section  
      if(sectionRect){
        // Check if the section is fully in the viewport
        if (sectionRect.bottom >= 0 && sectionRect.top <= window.innerHeight) {
            section.classList.add('hide_sticky'); // Add hide_sticky class when visible
            section.classList.remove('show_sticky'); // Remove show_sticky class
        } else {
            section.classList.remove('hide_sticky'); // Remove hide_sticky class when out of viewport
            section.classList.add('show_sticky'); // Add show_sticky class
        }
      }
    }
    

    
});





// When the user scrolls down 800px from the top of the document, resize the header's font size
window.addEventListener('scroll', function() {
    const stickyBar = document.getElementById('stickyfilter');
    
    // Check if the sticky bar has reached the top of the viewport
    if(stickyBar){
      if (stickyBar.getBoundingClientRect().top === 0) {
          stickyBar.classList.add('sticky');
      } else {
            stickyBar.classList.remove('sticky');
      }  
    }
    
});



